// Primary navigation structure.
//
// The mega-menu contents (product categories, subcategories, brands, services)
// are no longer built here — they are derived from live CMS data by
// `context/SiteDataContext.jsx`, so adding a category in the admin area updates
// the header without a code change. Only the top-level link order lives here,
// because it is a design decision rather than content.
export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Our Partners", to: "/partners" },
  {
    // Renamed from "Our Products" at the client's request. The route stays
    // /products so existing links and search rankings are unaffected.
    label: "Our Solutions",
    to: "/products",
    mega: "products",
  },
  {
    label: "Services",
    to: "/services",
    mega: "services",
  },
  { label: "Blogs", to: "/blog" },
  { label: "Contact Us", to: "/contact" },
];
